<ion-button fill="outline" size="large" color="dark">
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-icon [name]="iconName"></ion-icon>
        <ng-content></ng-content>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-button>
